// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable unicorn/no-this-assignment */
// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable no-console */

import SelectorEngine from '../../utils/dom/selector-engine';
import EventHandler from '../../utils/dom/event-handler';
import Select from '../../components/Select';

// class names
const CLASS_WRAPPER = 'p-activator-portal-resource-page';
const CLASS_VENUE_SELECT = 'lta-activator-resource-venue-select';
const CLASS_SPORTS_SELECT = 'lta-activator-resource-sports-select';
const CLASS_AGE_SELECT = 'lta-activator-resource-age-group-select';
const CLASS_ABILITY_SELECT = 'lta-activator-resource-ability-select';
const CLASS_MAIN_SELECT_OPTION = 'js-lta-select';
const CLASS_FILTER_BTN_DESKTOP = 'lta-activator-resource__btn';
const CLASS_FILTER_BTN_MOBILE = 'lta-activator-resource__btn-mobile';
const CLASS_FILTER_FORM = 'js-activator-portal-resource-search-form';

// selectors
const SELECTOR_WRAPPER = `.${CLASS_WRAPPER}`;
const SELECTOR_VENUE_SELECT = `.${CLASS_VENUE_SELECT}`;
const SELECTOR_SPORTS_SELECT = `.${CLASS_SPORTS_SELECT}`;
const SELECTOR_AGE_SELECT = `.${CLASS_AGE_SELECT}`;
const SELECTOR_ABILITY_SELECT = `.${CLASS_ABILITY_SELECT}`;
const SELECTOR_MAIN_SELECT_OPTION = `.${CLASS_MAIN_SELECT_OPTION}`;
const SELECTOR_FILTER_BTN_DESKTOP = `.${CLASS_FILTER_BTN_DESKTOP}`;
const SELECTOR_FILTER_BTN_MOBILE = `.${CLASS_FILTER_BTN_MOBILE}`;
const SELECTOR_FILTER_FORM = `.${CLASS_FILTER_FORM}`;

const CLICK_EVENT = 'click';

class ActivatorsPortalResource {
	constructor() {
		this._wrapper = SelectorEngine.findOne(SELECTOR_WRAPPER);
		if (!this._wrapper) {
			return;
		}
		this.initEvents();
		this.state = {
			selectedVenueType: [],
			selectedSports: [],
			selectedAgeGroup: [],
			selectedAbility: []
		};
	}

	initEvents() {
		// Events on Tabs Changes and Searches
		const venueType = SelectorEngine.findOne(SELECTOR_VENUE_SELECT, this._wrapper);
		const sports = SelectorEngine.findOne(SELECTOR_SPORTS_SELECT, this._wrapper);
		const ageGroup = SelectorEngine.findOne(SELECTOR_AGE_SELECT, this._wrapper);
		const ability = SelectorEngine.findOne(SELECTOR_ABILITY_SELECT, this._wrapper);

		if (venueType) {
			this.venueTypeElement = SelectorEngine.findOne(SELECTOR_MAIN_SELECT_OPTION, venueType);
			this.venueTypeSelect = Select.getInstance(this.venueTypeElement) || new Select(this.venueTypeElement);
			EventHandler.on(this.venueTypeSelect._selectNativeElement, 'change', (event) => {
				this.saveVenueType(event);
			});
		}

		if (sports) {
			this.sportsElement = SelectorEngine.findOne(SELECTOR_MAIN_SELECT_OPTION, sports);
			this.sportsSelect = Select.getInstance(this.sportsElement) || new Select(this.sportsElement);
			EventHandler.on(this.sportsSelect._selectNativeElement, 'change', (event) => {
				this.saveSports(event);
			});
		}

		if (ageGroup) {
			this.ageGroupElement = SelectorEngine.findOne(SELECTOR_MAIN_SELECT_OPTION, ageGroup);
			this.ageGroupSelect = Select.getInstance(this.ageGroupElement) || new Select(this.ageGroupElement);
			EventHandler.on(this.ageGroupSelect._selectNativeElement, 'change', (event) => {
				this.saveAgeGroup(event);
			});
		}

		if (ability) {
			this.abilityElement = SelectorEngine.findOne(SELECTOR_MAIN_SELECT_OPTION, ability);
			this.abilitySelect = Select.getInstance(this.abilityElement) || new Select(this.abilityElement);
			EventHandler.on(this.abilitySelect._selectNativeElement, 'change', (event) => {
				this.saveAbility(event);
			});
		}

		const applyFilter = SelectorEngine.findOne(SELECTOR_FILTER_BTN_DESKTOP, this._wrapper);
		const applyFilterMobile = SelectorEngine.findOne(SELECTOR_FILTER_BTN_MOBILE, this._wrapper);
		const formElement = SelectorEngine.findOne(SELECTOR_FILTER_FORM, this._wrapper);

		EventHandler.on(applyFilter, CLICK_EVENT, () => {
			this.generateQueryString(formElement);
		});

		EventHandler.on(applyFilterMobile, CLICK_EVENT, () => {
			this.generateQueryString(formElement);
		});
	}

	saveVenueType(event) {
		const selectedValues = [];
		// Loop through each option and add selected values to the array
		for (let index = 0; index < event?.target?.options?.length; index++) {
			if (event?.target?.options[index].selected) {
				selectedValues.push(event.target.options[index].value);
			}
		}
		this.state.selectedVenueType = selectedValues;
	}

	saveSports(event) {
		const selectedValues = [];
		// Loop through each option and add selected values to the array
		for (let index = 0; index < event?.target?.options?.length; index++) {
			if (event?.target?.options[index].selected) {
				selectedValues.push(event.target.options[index].value);
			}
		}
		this.state.selectedSports = selectedValues;
	}

	saveAgeGroup(event) {
		const selectedValues = [];
		// Loop through each option and add selected values to the array
		for (let index = 0; index < event?.target?.options?.length; index++) {
			if (event?.target?.options[index].selected) {
				selectedValues.push(event.target.options[index].value);
			}
		}
		this.state.selectedAgeGroup = selectedValues;
	}

	saveAbility(event) {
		const selectedValues = [];
		// Loop through each option and add selected values to the array
		for (let index = 0; index < event?.target?.options?.length; index++) {
			if (event?.target?.options[index].selected) {
				selectedValues.push(event.target.options[index].value);
			}
		}
		this.state.selectedAbility = selectedValues;
	}

	generateQueryString(formElement) {
		formElement.submit();
	}

	encodeParam(value) {
		return encodeURIComponent(value.replace(/&/g, '&amp;'));
	}
}

const globalActivatorsPortalResource = new ActivatorsPortalResource();
export default globalActivatorsPortalResource;
